import { Typography } from '@mui/material';
import { MprcClickable } from 'components';

export const TrainingIndexResult = (props: { value: number | null; onClick?: () => void; }) => {
    return (
        props.onClick ?
            <MprcClickable onClick={props.onClick}>
                <Typography variant="h3" color="primary.light">{props.value != null ? `${props.value}%` : "-"}</Typography>
            </MprcClickable>
            :
            <Typography variant="h3" color="primary.light">{props.value}%</Typography>
    );
};
